<template>
  <section id="WinEmailEntry" class="win-email-entry">
    <div class="headline-container">
      <check-mark-large-gold v-if="wentForIt==='gold'" class="check-mark"></check-mark-large-gold>
      <check-mark-large-normal v-if="wentForIt==='normal'" class="check-mark"></check-mark-large-normal>
      <h1 class="main-headline"> {{headlineText}} </h1>
      <p>{{subheadText}}</p>
    </div>

    <div class="activity-container">
      <h2 class="sub-headline">You’ve completed {{numCompleted}} out of {{steps.length}} activities.</h2>
      <ul class="activities">
        <li v-for="step in steps"  :key="step.id"  class="activities-list-item">
          <win-activity :completeStep="completeStep" :created="created" :stepId="step.id" :step="step.step" :completed="step.completed" :gold-completed="step.goldCompleted"></win-activity>
        </li>
      </ul>
      <p class="activity-subtext">Keep journeying to new experiences with us each week for more chances to win weekly prizes. If you've completed a challenge and it's not indicated with a checkmark, click the small, colored icon.</p>
    </div>
    
    <div class="return-block">
      <p>Haven't joined the Wander &amp; Win challenge yet?</p>
      <button class="return-cta" v-on:click="goToForm()">head to the sign up page</button>
    </div>
    
    <div v-if="couponUrl.length > 0" class="coupon-block">
      <p>Don’t forget to scoop up a taste of Zespri SunGold Kiwifruit if you haven’t already!</p>
      <a class="download-cta" :href="couponUrl" target="_blank">
        <i class="button-icon coupon-icon"><coupon-icon /></i>
        download the coupon
      </a>
    </div>

    <div class="social-block">
      <img class="flowers" data-src="./assets/win/isolated-flowers.png">
      <div class="social-hash-tag">#WanderWithZespri</div>
      <div class="social-links">
        <p>Get your friends and family in on the wandering journey, and share photos of your adventures along the way.</p>
        <div class="social-icons">
          <a @click.prevent="shareFacebook"><facebook-icon-large class="social-icon"></facebook-icon-large></a>
          <a @click.prevent="sharePinterest"><pinterest-icon-large class="social-icon"></pinterest-icon-large></a>
          <a @click.prevent="shareTwitter"><twitter-icon-large class="social-icon"></twitter-icon-large></a>
        </div>
      </div>
    </div>

    <a href="https://zesprikiwi.com/" target="_blank" class="learn-more-cta">Learn more about Zespri Sungold</a>
  </section>
</template>

<script>
import axios from 'axios'
import FacebookIconLarge from '../assets/icons/facebook-icon-large.svg?inline'
import PinterestIconLarge from '../assets/icons/pinterest-icon-large.svg?inline'
import TwitterIconLarge from '../assets/icons/twitter-icon-large.svg?inline'
import CheckMarkLargeNormal from '../assets/icons/check-mark-large-normal.svg?inline'
import CheckMarkLargeGold from '../assets/icons/check-mark-large-gold.svg?inline'
import CouponIcon from '../assets/icons/coupon.svg?inline'
import WinActivity from '../components/WinActivity.vue'
import store from '../store'

export default{
  name: 'win-email-entry',
  components: {
    'facebook-icon-large': FacebookIconLarge,
    'pinterest-icon-large': PinterestIconLarge,
    'twitter-icon-large': TwitterIconLarge,
    'check-mark-large-normal': CheckMarkLargeNormal,
    'check-mark-large-gold': CheckMarkLargeGold,
    'coupon-icon': CouponIcon,
    'win-activity': WinActivity
  },
  computed: {
    steps () {
	    return store.state.steps
    },
    created () {
	    return store.state.created
    },
    numCompleted () {
	    return this.steps.reduce((p,c)=>{return p + (c.completed? 1:0)},0)
    },
    wentForIt(){
      return store.state.wentForIt
    },

    couponUrl(){
      return store.state.couponUrl
    },

    headlineText(){
      if(this.wentForIt !== ''){
        return `You went for ${this.wentForIt === 'gold'? 'the GOLD':'it'} and now you can win.`
      } else if( this.numCompleted === this.steps.length ){
        return 'Thanks for Wandering With Us'
      }
      else{
        return 'Get Ready to Wander'
      }
    },

    subheadText(){
      if(this.wentForIt !== ''){
        return 'For completing this week’s challenge, you got an extra entry into our grand prize drawing!'
      } else if( this.numCompleted === this.steps.length ){
        return 'The drawing for our grand prize winner is coming soon. In the meantime, follow us on social for all things adventure and kiwifruit!'
      }
      else{
        return 'Your next challenge is coming soon.'
      }
    }
  },
  methods:{
    completeStep(id, num){
      console.log(id, num)
      store.commit('showLoader')
      axios.post(`${store.state.backendUrl}/completeUserStep`, {
        step: num, 
        stepId: id,
        goldCompleted: false
      }).then(resp => {
        store.commit('setCreated', resp.data.created)
        store.commit('setSteps', resp.data.steps)
        store.commit('setWentForItStatus', 'normal' )
        store.commit('goToWinEmailEntry')
        this.$cookies.set('user', resp.data, -1)
      }).catch((err) => {
        console.log(err)
      }).finally(() => {
        store.commit('hideLoader')
      })
    },
    shareFacebook(){
      store.commit('shareFacebook')
    },
    shareTwitter(){
      store.commit('shareTwitterActivation')
    },
    sharePinterest(){
      store.commit('sharePinterestActivation')
    },
    goToForm() {
      store.commit('goToWinForm')
    }
  }
}
</script>

<style scoped lang="scss">
/** split-container **/
@import '../theme';

.win-email-entry {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 100px 0;
  z-index: zespri-layer(normal);

  @include media-breakpoint-up(md) {
    margin: 0 auto;
  }
}

.headline-container {
  margin: 0 0 50px 0;
  @include media-breakpoint-up(md) {
    max-width: 410px;
  }

  .check-mark {
    width: 80px;
    height: 80px;
  }

  .main-headline {
    @include zespri-body-font;
    text-transform: none;
    font-size: 30px;
    line-height: 32px;
    margin: 15px 0;
  }
}

.activity-container {
    max-width: 410px;

  .sub-headline {
    @include zespri-title-font;
    text-transform: uppercase;
    font-size: 16px;
  }

  .activities {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    list-style: none;
    padding: 0 0 15px 0;
  }

  .activity-subtext {
    max-width: 310px;
    margin: 0 auto 40px auto;
  }
}


.return-block {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 30px 20px;
  margin: 20px 0 10px 0;
  border-top: 2px solid zespri-brand-color(dark-green);
  border-bottom: 2px solid zespri-brand-color(dark-green);

  @include media-breakpoint-up(md) {
    flex-direction: row;
    align-items: center;
    justify-content: center;
    max-width: 520px;
  }

  p {
    margin: 0 0 30px 0;
    @include media-breakpoint-up(md) {
      margin: 0;
    }
  }

  .return-cta {
    @include cta-button(zespri-brand-color(white), zespri-brand-color(dark-green), zespri-brand-color(green));
    min-width: 200px;
    white-space: nowrap;

    @include media-breakpoint-up(md) {
      margin-left: 15px;
    }

    .button-icon {
      display: inline-block;
      margin-right: 8px;
      fill: zespri-brand-color(red);

      &.coupon-icon {
        width: 22px;
        height: 18px;
      }
    }
  }
}


.coupon-block {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  margin: 0 0 20px 0;

  @include media-breakpoint-up(md) {
    flex-direction: row;
    align-items: center;
    justify-content: center;
    max-width: 520px;
  }

  p {
    margin: 0 0 30px 0;
    @include media-breakpoint-up(md) {
      margin: 0;
    }
  }

  .download-cta {
    @include cta-button(zespri-brand-color(white), zespri-brand-color(dark-green), zespri-brand-color(green));
    white-space: nowrap;
    
    @include media-breakpoint-up(md) {
      margin-left: 15px;
    }

    .button-icon {
      display: inline-block;
      margin-right: 8px;
      fill: zespri-brand-color(red);

      &.coupon-icon {
        width: 22px;
        height: 18px;
      }
    }
  }
}

.social-block {
  position: relative;
  box-sizing: border-box;
  background-color: zespri-brand-color(dark-green);
  padding: 25px;
  margin: 0 0 40px 0;

  &:before {
    content: '';
    position: absolute;
    bottom: -80px;
    right: 24px;
    z-index: -1;
    width: 120px;
    height: 160px;
    background-image: url('../assets/win/isolated-flowers-fern.png');
    background-repeat: no-repeat;
    background-size: contain;
  }

  @include media-breakpoint-up(md) {
    max-width: 520px;
  }

  .social-hash-tag {
    @include zespri-title-font;
    color: zespri-brand-color(yellow);
    text-transform: uppercase;
    margin: 0 0 20px 0;
  }

  .social-links {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    
    @include media-breakpoint-up(md) {
      flex-direction: row;
    }

    p {
      color: zespri-brand-color(white);
      
      @include media-breakpoint-up(md) {
        width: 60%
      }
    }

    .social-icons {
      display: flex;
      flex-direction: row;

      .social-icon {
        display: block;
        width: 45px;
        margin: 0 8px;
      }
    }
  }

  .flowers {
    position: absolute;
    top: -15px;
    left: -30px;
    width: 60px;
  }

  .flowers-fern {
    position: absolute;
    z-index: -10;
  }
}

.learn-more-cta {
  @include cta-button(zespri-brand-color(dark-green), zespri-brand-color(white), zespri-brand-color(dark-green));
}

</style>
